<script lang="ts">
  import type { Vec3 } from '../../scene/types';

  let {
    label,
    value,
    step = 0.1,
    onchange,
    testid,
  }: { label: string; value: Vec3; step?: number; onchange: (v: Vec3) => void; testid?: string } = $props();

  function set(i: number, raw: string) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return;
    const v: Vec3 = [...value];
    v[i] = n;
    onchange(v);
  }
</script>

<div class="vec3" data-testid={testid}>
  <span class="label">{label}</span>
  {#each [0, 1, 2] as i (i)}
    <label class="axis a{i}">
      <span>{'XYZ'[i]}</span>
      <input
        type="number"
        {step}
        value={value[i]}
        onchange={(e) => set(i, (e.currentTarget as HTMLInputElement).value)}
      />
    </label>
  {/each}
</div>

<style>
  .vec3 {
    display: grid;
    grid-template-columns: 64px repeat(3, 1fr);
    gap: 4px;
    align-items: center;
    font-size: 12px;
  }
  .label {
    color: var(--muted);
  }
  .axis {
    display: flex;
    align-items: center;
    gap: 2px;
  }
  .axis span {
    font-size: 10px;
    width: 9px;
  }
  .a0 span {
    color: #e87a6a;
  }
  .a1 span {
    color: #7fcf8f;
  }
  .a2 span {
    color: #6aa8e8;
  }
  input {
    padding: 2px 4px;
    font-size: 12px;
    min-width: 0;
  }
</style>
